
export const validateUUID = (id: string | undefined | null): boolean => {
  if (!id || id === 'not-set' || id === '' || id === 'null' || id === 'undefined') return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

export const sanitizeUUID = (id: string | undefined | null): string | null => {
  if (validateUUID(id)) {
    return id as string;
  }
  return null;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const sanitizeString = (input: string, maxLength: number = 1000): string => {
  if (typeof input !== 'string') return '';
  return input.replace(/[<>]/g, '').trim().substring(0, maxLength);
};

export const validateRequiredString = (value: string | undefined | null): boolean => {
  return typeof value === 'string' && value.trim().length > 0;
};
